import { Serializable } from '@/models/core/serializable';

export class Tag implements Serializable<Tag> {
  tagID: number;
  tagContent: string;
  flg: boolean = false;
  isClosable: boolean = false;

  deserialize(input: any): Tag {
    this.tagID = input.tagID;
    this.tagContent = input.tag;
    if (input.flg !== undefined) {
      this.flg = input.flg;
    }
    if (input.isClosable) {
      this.isClosable = input.isClosable;
    } else {
      this.isClosable = false;
    }
    return this;
  }
}
